import React from "react";
import * as styles from "./TreeStamp.module.css";
import { Image } from "../../../types";
import { Link } from "../Link/Link";
import { KontentImageElement } from "../KontentImageElement/KontentImageElement";
import { StaticImage } from "gatsby-plugin-image";

export interface TreeStampProps {
  image?: Image;
  treeId?: string;
  name: string;
  species?: string;
  cta?: {
    label: string;
    href: string;
    target: "_blank" | "_self";
  };
  clickable?: boolean;
  style?: "listing" | "overlay";
}

export const TreeStamp: React.FC<TreeStampProps> = ({
  image,
  name,
  treeId,
  species,
  cta,
  clickable,
  style = "listing",
}) => {
  const stampClasses = [styles.treeStamp];
  style === "listing" && stampClasses.push(styles.listing);
  style === "overlay" && stampClasses.push(styles.overlay);

  const renderStamp = () => {
    return (
      <div className={stampClasses.join(" ")}>
        <div className={styles.stampContent}>
          {image ? (
            <div className={styles.image}>
              <KontentImageElement
                image={image.item}
                alt={image.alt}
                height={style === "overlay" ? 110 : 245}
                width={style === "overlay" ? 104 : 237}
              />
            </div>
          ) : (
            <div className={styles.image}>
              <StaticImage
                src="./assets/tree-placeholder.png"
                alt="Linda Hall Library Arboretum logo"
                placeholder="blurred"
                layout="constrained"
                width={245}
                height={237}
              />{" "}
            </div>
          )}
          <div className={styles.detailContainer}>
            <div>
              <div className={styles.name}>
                {name}
                {treeId && (
                  <>
                    <br /> {treeId}
                  </>
                )}
              </div>
              {species && <div className={styles.species}>{species}</div>}
            </div>
            {cta && cta?.href && (
              <div className={styles.link}>
                {clickable ? (
                  <span>{cta?.label}</span>
                ) : (
                  <Link to={cta.href} target={cta?.target}>
                    {cta.label || "View Details"}
                  </Link>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return cta && cta?.href && clickable ? (
    <div className={styles.clickable}>
      <Link to={cta.href} target={cta.target || "_self"}>
        {renderStamp()}
      </Link>
    </div>
  ) : (
    renderStamp()
  );
};
